import { ListBox } from '@adobe/react-spectrum';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Popover content for `MultiSelect`. Renders either an empty-state message (text-only)
 * or the Spectrum `<ListBox>`. Private subcomponent of `MultiSelect`.
 */
export function MultiSelectListBox(_ref) {
  var listBoxRef = _ref.listBoxRef,
    listBoxId = _ref.listBoxId,
    loadingState = _ref.loadingState,
    children = _ref.children,
    selectedKeys = _ref.selectedKeys,
    disabledKeys = _ref.disabledKeys,
    onSelectionChange = _ref.onSelectionChange,
    ariaLabel = _ref.ariaLabel,
    emptyMessage = _ref.emptyMessage;
  if (emptyMessage != null) {
    return /*#__PURE__*/_jsx("div", {
      className: "dh-multi-select-empty",
      children: emptyMessage
    });
  }
  return /*#__PURE__*/_jsx(ListBox, {
    ref: listBoxRef,
    id: listBoxId,
    selectionMode: "multiple",
    selectedKeys: selectedKeys,
    onSelectionChange: onSelectionChange,
    disabledKeys: disabledKeys,
    "aria-label": ariaLabel,
    isLoading: loadingState === 'loadingMore',
    UNSAFE_style: {
      maxHeight: 'inherit'
    },
    children: children
  });
}
export default MultiSelectListBox;
//# sourceMappingURL=MultiSelectListBox.js.map